import SvgIcon from "./SvgIcon";
import IconButton from "./IconButton";

interface Props {
    className?: string;
    width?: string;
    height?: string;
    sizeInPixel?: number;
}

export default function SymbolPropaneTankIcon({className = '', width = '', height = '', sizeInPixel}: Props) {
    if (sizeInPixel) {
        width = sizeInPixel + 'px';
        height = sizeInPixel + 'px';
    }
    return <>
        <SvgIcon
            defaultFill={'fill-amber-500'}
            className={className}
            width={width}
            height={height}>
            <path d="M320-80q-66 0-113-47t-47-113v-320q0-57 34-99t86-56v-85q0-33 23.5-56.5T360-880h240q33 0 56.5 23.5T680-800v85q52 14 86 56t34 99v320q0 66-47 113T640-80H320Zm-80-360h480v-120q0-33-23.5-56.5T640-640H320q-33 0-56.5 23.5T240-560v120Zm80 280h320q33 0 56.5-23.5T720-240v-120H240v120q0 33 23.5 56.5T320-160Zm160-280Zm0 80Zm0-40Zm40-320h80v-80H360v80h80q0-17 11.5-28.5T480-760q17 0 28.5 11.5T520-720Z"/>
        </SvgIcon>
    </>;
}

interface ButtonProps {
    className?: string;
    onClick?: () => void;
    title: string;
    svgClassName?: string;
}

export function SymbolPropaneTankButton({className = '', onClick, title, svgClassName}: ButtonProps) {
    return <>
        <IconButton
            className={className}
            onClick={onClick}
            title={title}
        >
            <SymbolPropaneTankIcon className={svgClassName}/>
        </IconButton>
    </>;
}